/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import reverse from 'lodash/reverse';
import mapKeys from 'lodash/mapKeys';
import {
  Grid,
  Button,
  Dropdown,
  Divider,
  Loader,
  Container,
  TextArea,
  Form,
  Label,
  Segment
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import {
  getCampaignWithPromotedObjects,
  getCampaignsWithoutAdsets
} from '../../../fbApi/Campaign';
import months from '../../../utils/months';
import { getProductSets } from '../../../fbApi/ProductCatalog';
import { getAccount } from '../../../fbApi/Account';
import {
  getPageWithPageToken,
  getPages,
  getPageBackedInstagramAccounts
} from '../../../fbApi/Page';
import { scrollToBottom } from './AdLibraryLaunchActions';
import AdLibraryLaunchCard from './AdLibraryLaunchCard';
import AdLibraryLaunchFieldsComponent from './AdLibraryLaunchFieldsComponent';
import './AdLibraryLaunch.css';

class AdLibraryLaunch extends Component {
  async componentDidMount() {
    await this.fetchPages(this.props.launchStateFromParent.pages);
  }

  async componentDidUpdate(prevProps) {
    const { adPrototype: prevAdPrototype } = prevProps;
    const { adPrototype, launchStateFromParent } = this.props;
    if (prevAdPrototype.id !== adPrototype.id) {
      const {
        campaign_ids: campaignsFromParent,
        form,
        pages
      } = launchStateFromParent;
      await this.fetchPages(pages);
      if (campaignsFromParent && campaignsFromParent.length > 0) {
        this.initializeAdsetSelection(campaignsFromParent, form);
      }
    }
  }

  initializeAdsetSelection = (campaignsFromParent, formFromParent) => {
    const { adsets: adsetsAlreadyInForm } = formFromParent;
    if (adsetsAlreadyInForm.length <= 0) {
      const newForm = { ...formFromParent };
      const returnAdsetParamForForm = campaignsFromParent.map(
        (campaignObject) => {
          const { id, adsets } = campaignObject;
          return {
            campaignId: id,
            adsets: [],
            adsetsData: adsets
          };
        }
      );
      newForm.adsets = returnAdsetParamForForm;
      this.setFormState(newForm);
    }
  };

  fetchPages = async (pagesFromParentState) => {
    if (!(pagesFromParentState && pagesFromParentState.length <= 0)) {
      return;
    }

    const { getFbToken, user } = this.props;

    const token = getFbToken();
    const pages = await getPages(token, user.groups[0]);

    if (!pages || pages.length < 1) {
      return;
    }

    const filteredPages = pages[0].data
      .concat(pages[1].data)
      .filter((page) => page.access_token);
    const pagesOptions = sortBy(
      map(filteredPages, (page, index) => ({
        key: index,
        value: { pageId: page.id, access_token: page.access_token },
        text: page.name
      })),
      'text'
    );
    const parameters = { pages: pagesOptions };

    this.setStateInParent(parameters);
  };

  onAccountSelect = async (event, data) => {
    const { launchStateFromParent } = this.props;
    const { form, token } = launchStateFromParent;

    const account = find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    form.accountId = accountId;
    form.accountName = account.text;
    form.adsets = [];

    this.setStateInParent(
      {
        showYearLoader: true,
        showAdsetsSelector: false,
        showMonthSelector: false,
        showYearSelector: false,
        data: null,
        years: [],
        campaign_ids: [],
        filteredCampaigns: [],
        selectedCampaigns: '',
        selectedYear: '',
        selectedMonth: ''
      },
      async () => {
        await this.getCampaigns(accountId, token);
        const accountData = await getAccount(accountId, token);
        if (
          accountData &&
          accountData.adspixels &&
          accountData.adspixels.data[0]
        ) {
          form.pixel = accountData.adspixels.data[0].id;
        } else {
          form.pixel = '';
        }
        this.setFormState(form);
      }
    );
  };

  getCampaigns = async (id, token) => {
    try {
      const campaigns = await getCampaignsWithoutAdsets(id, token);
      const result = campaigns.data;

      const assocCampaigns = [];
      const campaignMonths = [];
      const years = [];

      map(reverse(sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: [],
          campaigns: []
        };
      });

      map(reverse(sortBy([...result], 'start_time')), async (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);

        const existentYear = years.filter((item) => item.text === year);

        if (existentYear.length === 0) {
          years.push({
            value: year,
            text: year
          });
        }

        assocCampaigns[year + month].month = month;
        assocCampaigns[year + month].year = year;
        assocCampaigns[year + month].ids.push(campaign.id);
        assocCampaigns[year + month].campaigns.push({
          id: campaign.id,
          name: campaign.name,
          objective: campaign.objective
        });
      });

      mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = map(campaignMonths, (op, index) => {
        const month = months.filter((item) => item.shortName === op.month);

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          campaigns: op.campaigns,
          year: op.year
        };
      });

      this.setStateInParent({
        data: result,
        campaigns: campaignOpts,
        filteredCampaigns: campaignOpts,
        showYearSelector: true,
        showYearLoader: false,
        years
      });
    } catch (error) {
      console.log(error);
    }
  };

  getAdSetsForCampaignMonth = async (selectedMonthName) => {
    try {
      if (selectedMonthName.trim() === '') throw Error('Select a month name.');
      const { launchStateFromParent } = this.props;
      const { filteredCampaigns, token } = launchStateFromParent;
      const campaignMonthToUse = filteredCampaigns.find((campaign) => {
        const { text: monthName } = campaign;
        return monthName === selectedMonthName;
      });
      const { campaigns } = campaignMonthToUse || {};
      const campaignIds =
        campaigns && campaigns.length > 0
          ? campaigns.map((campaign) => {
              const { id } = campaign;
              return id;
            })
          : [];

      const campaignsWithAdsets =
        campaignIds.length > 0
          ? await Promise.all(
              campaignIds.map(async (id) => {
                const getCampaignResult = await getCampaignWithPromotedObjects(
                  id,
                  token
                );
                return getCampaignResult;
              })
            )
          : [];

      const filteredCampaignsWithAdsets = campaignsWithAdsets.filter(
        (campaign) => {
          const { adsets } = campaign || {};
          const { data: adsetData } = adsets || [];
          return adsetData && adsetData.length > 0;
        }
      );

      const campaignsWithMappedAdsets = filteredCampaignsWithAdsets.map(
        (campaignWithAdsets) => {
          const { adsets } = campaignWithAdsets || {};
          const shallowCampaignCopy = campaignWithAdsets;
          const { data: adsetData } = adsets || [];
          const mappedAdsetForDropdown =
            adsetData && adsetData.length > 0
              ? map(adsetData, (adsetObject, index) => {
                  const {
                    id,
                    name,
                    promoted_object: promotedObject,
                    ads
                  } = adsetObject;
                  return {
                    key: index,
                    value: id,
                    text: name,
                    promotedObject,
                    ads: ads && ads.data ? ads.data : []
                  };
                })
              : [];
          shallowCampaignCopy.adsets = mappedAdsetForDropdown;
          return shallowCampaignCopy;
        }
      );
      campaignMonthToUse.campaigns = campaignsWithMappedAdsets;

      return campaignMonthToUse;
    } catch (error) {
      toast.warn(
        `Something went wrong. Select the month again or refresh the page`,
        {
          position: 'bottom-left',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
      console.log(
        'Something went wrong in getAdSetsForCampaignMonth():',
        error
      );
      return [];
    }
  };

  onYearSelect = (event, { value }) => {
    const { launchStateFromParent } = this.props;
    const filteredCampaigns = launchStateFromParent.campaigns.filter(
      (val) => val.year === value
    );

    this.setStateInParent({
      showAdsetsSelector: false,
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedCampaigns: '',
      selectedYear: value,
      selectedMonth: ''
    });
  };

  onMonthSelect = (event, { value, options }) => {
    const { launchStateFromParent } = this.props;
    this.setStateInParent(
      {
        showAdsetLoader: true,
        showAdsetsSelector: false,
        form: { ...launchStateFromParent.form, adsets: [] }
      },
      async () => {
        const selectedCampaignMonth = find(
          options,
          (option) => option.value === value
        );
        const ids = selectedCampaignMonth.value.split(',');
        const monthInYear = selectedCampaignMonth.text;
        const month = months.find((item) => item.monthName === monthInYear);
        const { monthNumber, monthName } = month || {};
        const selectedMonth = monthNumber || new Date().getMonth() + 1;
        const selectedCampaignMonthWithAdsets = await this.getAdSetsForCampaignMonth(
          monthName || selectedCampaignMonth.text
        );
        const { campaigns } = selectedCampaignMonthWithAdsets || {};

        if (!campaigns || campaigns.length <= 0) {
          toast.warn(
            `No adsets could be retrieved for the selected campaign month`,
            {
              position: 'bottom-left',
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
          this.setStateInParent({
            showAdsetLoader: false,
            showAdsetsSelector: false,
            selectedMonth,
            campaign_ids: [],
            selectedCampaigns: ids.join(',')
          });
        } else {
          const newForm = { ...launchStateFromParent.form };

          const initialAdsetsForForm = campaigns.map((campaign) => ({
            campaignId: campaign.id,
            adsets: [],
            adsetsData: campaign.adsets
          }));
          newForm.adsets = initialAdsetsForForm;

          this.setStateInParent({
            showAdsetLoader: false,
            showAdsetsSelector: true,
            selectedMonth,
            campaign_ids: campaigns || [],
            selectedCampaigns: ids.join(','),
            form: newForm
          });
        }
      }
    );
  };

  // Returns the objective name of the campaign to be shown in the adset selector
  getObjectiveName = (objective) => {
    if (objective === 'CONVERSIONS') {
      return 'Conversions';
    } else if (objective === 'VIDEO_VIEWS') {
      return 'Video';
    } else if (objective === 'LINK_CLICKS') {
      return 'Traffic';
    }

    return 'DAA';
  };

  renderTags = (adPrototype) => {
    const tags = this.props.adPrototypesTags.filter(
      (tag) => tag.ad_prototype_id === adPrototype.id
    );

    return (
      <div>
        {tags && tags.length > 0 ? (
          tags.map((tag) => <Label>{tag.value}</Label>)
        ) : (
          <div>
            <Label>None</Label>
          </div>
        )}
      </div>
    );
  };

  handleAdChange = (event, { name, value }) => {
    const { launchStateFromParent } = this.props;
    const form = launchStateFromParent.form;
    form[name] = value;

    this.setFormState(form);
  };

  handleAdCardChange = (event, { value, cardId }) => {
    const { launchStateFromParent } = this.props;
    const form = launchStateFromParent.form;

    let card = form.cards.find((item) => item.cardId === cardId);
    if (!card) {
      card = { cardId, destinationUrl: value };
      form.cards.push(card);
    } else {
      card.destinationUrl = value;
    }

    this.setFormState(form);
  };

  onProductCatalogSelection = async (event, data) => {
    const { value } = data;
    const { launchStateFromParent } = this.props;
    const { form, token } = launchStateFromParent;

    const result = await getProductSets(token, value);
    const productSets = result ? result.data : [];
    const productSetSelectionList = productSets.map((productSet, index) => ({
      key: index,
      text: productSet.name,
      value: productSet.id
    }));

    form.productCatalog = value;

    this.setStateInParent({ form, productSets: productSetSelectionList });
  };

  onProductSetSelection = async (event, data) => {
    const { value } = data;
    const { launchStateFromParent } = this.props;
    const { form } = launchStateFromParent;

    form.productSet = value;

    this.setFormState(form);
  };

  onDescriptionSelection = async (event, data) => {
    const { value } = data;
    const { launchStateFromParent } = this.props;
    const { form } = launchStateFromParent;

    form.description = value;

    this.setFormState(form);
  };

  // The display URL field is preselected in the form if a selected adset has an ad with a value for the display url
  getDisplayUrl = (ads) => {
    const { launchStateFromParent } = this.props;
    const { form } = launchStateFromParent;

    if (form.displayUrl) {
      return;
    }

    let displayUrl = '';
    ads.forEach((ad) => {
      if (!displayUrl) {
        const objectStorySpec = ad.creative.object_story_spec;
        if (
          objectStorySpec &&
          objectStorySpec.video_data &&
          objectStorySpec.video_data.call_to_action &&
          objectStorySpec.video_data.call_to_action.value
        ) {
          displayUrl =
            objectStorySpec.video_data.call_to_action.value.link_caption;
        } else if (objectStorySpec.link_data) {
          displayUrl = objectStorySpec.link_data.link;
        } else if (objectStorySpec.template_data) {
          displayUrl = objectStorySpec.template_data.link;
        }
        form.displayUrl = displayUrl;
        this.setFormState(form);
      }
    });
  };

  onAdsetSelection = (e, { value, options, campaignid }) => {
    const { launchStateFromParent } = this.props;
    const { form, pages } = launchStateFromParent;

    const adset = find(form.adsets, (option) => {
      return option.campaignId === campaignid;
    });

    const selectedAdsets = options.filter((item) => value.includes(item.value));

    if (selectedAdsets.length > 0) {
      let ads = [];
      selectedAdsets.forEach((item) => {
        ads = ads.concat(item.ads);
      });

      if (ads.length > 0) {
        this.getDisplayUrl(ads);
        const pageId = ads[0].creative.object_story_spec.page_id;

        if (pageId && !form.pageId) {
          const page = pages.find((item) => item.value.pageId === pageId);
          if (page) {
            this.onSelectPage({}, { value: page.value, options: pages });
          }
        }
      }
    }

    if (!adset) {
      const newAdset = {
        campaignId: campaignid,
        adsets: value,
        adsetsData: options
      };
      form.adsets.push(newAdset);
    } else {
      adset.adsets = value;
      adset.adsetsData = options;
    }

    this.setFormState(form);
  };

  relaunchAd = async () => {
    const { launchAdFromParent, adPrototype } = this.props;
    if (launchAdFromParent) {
      await launchAdFromParent(adPrototype);
    }
  };

  onSelectPage = async (event, { value, options }) => {
    const { launchStateFromParent } = this.props;
    const form = launchStateFromParent.form;

    const selectedPage = find(options, (opt) => {
      return opt.value === value;
    });

    const { value: selectedPageValue } = selectedPage || {};
    const { pageId, access_token: accessToken } = selectedPageValue;

    const pageResult = await getPageWithPageToken(pageId, accessToken);
    const { instagram_accounts: instagramAccounts } = pageResult || {};
    const { data: instagramAccountsData } = instagramAccounts || {};

    if (instagramAccountsData) {
      const instagramAccoutToUse = instagramAccounts[0];
      form.instagramAccount = instagramAccoutToUse
        ? instagramAccoutToUse.id
        : '';
    } else {
      const instagramResult = await getPageBackedInstagramAccounts(
        pageId,
        accessToken
      );
      const { data: instagramData } = instagramResult || {};
      if (instagramData && instagramData[0]) {
        form.instagramAccount = instagramData[0].id;
      }
    }

    form.pageId = pageId;
    form.pageAccessToken = accessToken;

    this.setStateInParent({
      form,
      selectedPage: selectedPageValue
    });
  };

  toggleDebugLog = () => {
    const { launchStateFromParent } = this.props;
    const { debugLogOpen } = launchStateFromParent;
    this.setStateInParent(
      {
        debugLogOpen: !debugLogOpen
      },
      () => {
        scrollToBottom();
      }
    );
  };

  setFormState = (formToUse) => {
    const parameters = { form: formToUse };
    this.setStateInParent(parameters);
  };

  setStateInParent = (parameters, callback = null) => {
    const { adPrototype, setLaunchStateInParent } = this.props;
    const { id: adPrototypeId } = adPrototype;
    if (setLaunchStateInParent) {
      setLaunchStateInParent(adPrototypeId, parameters, callback);
    }
  };

  render() {
    const {
      accounts,
      adPrototype,
      productCatalogs,
      getFbToken,
      launchStateFromParent,
      debugLogContent,
      needToRelaunchAd
    } = this.props;
    const {
      form,
      showYearSelector,
      showMonthSelector,
      selectedYear,
      years,
      filteredCampaigns,
      selectedCampaigns,
      showYearLoader,
      showMonthLoader,
      showAdsetLoader,
      campaign_ids: campaignIds,
      productSets,
      log,
      showAdsetsSelector,
      pages,
      processing,
      selectedPage,
      debugLogOpen,
      token,
      currentThumbnail,
      thumbnails
    } = launchStateFromParent;

    const {
      description,
      productSet,
      productCatalog,
      destinationUrl,
      footerUrl,
      adsets: formAdsetsObjects,
      cards: formCards
    } = form;
    const { type } = adPrototype;
    const disableDisplayUrl =
      type === 'Canvas' || type === 'Carousel' || type === 'Collection';
    return (
      <div>
        <Grid stackable doubling>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Dropdown
                placeholder="Pages"
                search
                selection
                loading={!pages || pages.length < 1}
                disabled={!pages || pages.length < 1}
                options={pages}
                value={selectedPage}
                onChange={this.onSelectPage}
              />
              <Divider hidden />
              {!disableDisplayUrl ? (
                <Form.Input
                  placeholder="Display Url"
                  type="text"
                  name="displayUrl"
                  value={form.displayUrl}
                  onChange={this.handleAdChange}
                  className="ad-library-display-url"
                />
              ) : null}
              <Divider hidden />
              <Dropdown
                placeholder="Account"
                search
                selection
                value={form.accountId}
                options={accounts}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              {showYearSelector ? (
                <Dropdown
                  placeholder="Year"
                  search
                  selection
                  value={selectedYear}
                  options={years}
                  onChange={this.onYearSelect}
                />
              ) : showYearLoader ? (
                <Container>
                  <Loader inline className="active" />{' '}
                </Container>
              ) : null}
              <Divider hidden />
              {showMonthSelector ? (
                <Dropdown
                  placeholder="Month"
                  search
                  selection
                  options={filteredCampaigns}
                  value={selectedCampaigns}
                  onChange={this.onMonthSelect}
                />
              ) : showMonthLoader ? (
                <Container>
                  <Loader inline className="active" />{' '}
                </Container>
              ) : null}
              <Divider hidden />
              {showAdsetLoader ? (
                <Container>
                  <Loader inline className="active" />{' '}
                </Container>
              ) : (
                <div
                  style={{
                    maxHeight: 250,
                    overflowY: 'scroll',
                    padding: '1em'
                  }}
                >
                  {showAdsetsSelector && campaignIds
                    ? campaignIds.map((campaign) => {
                        const { objective, id, adsets } = campaign || {};
                        const adsetObject = formAdsetsObjects.find(
                          (adsetObj) => adsetObj.campaignId === id
                        );
                        const { adsets: adsetsValue } = adsetObject || {};
                        return (
                          <div>
                            <Label
                              size="small"
                              pointing="below"
                              key={`${id}-label`}
                            >
                              <b>{this.getObjectiveName(objective)}</b>
                            </Label>
                            <br />
                            <Dropdown
                              className="ad-library-launch-adset"
                              placeholder="Adsets"
                              search
                              multiple
                              selection
                              campaignid={id}
                              options={adsets || []}
                              value={adsetsValue || []}
                              onChange={this.onAdsetSelection}
                            />
                            <Divider hidden />
                          </div>
                        );
                      })
                    : null}
                </div>
              )}
            </Grid.Column>
            <Grid.Column>
              <AdLibraryLaunchCard
                adPrototype={adPrototype}
                renderTags={this.renderTags}
                fbToken={token}
                currentThumbnail={currentThumbnail}
                setStateInGrandparent={this.setStateInParent}
              />
            </Grid.Column>
            <Grid.Column>
              <AdLibraryLaunchFieldsComponent
                adPrototype={adPrototype}
                relaunchAd={this.relaunchAd}
                processing={processing}
                handleAdCardChange={this.handleAdCardChange}
                handleAdChange={this.handleAdChange}
                onProductCatalogSelection={this.onProductCatalogSelection}
                productCatalog={productCatalog}
                productCatalogs={productCatalogs}
                onProductSetSelection={this.onProductSetSelection}
                productSet={productSet}
                productSets={productSets}
                description={description}
                destinationUrl={destinationUrl}
                footerUrl={footerUrl}
                formCards={formCards}
                onDescriptionSelection={this.onDescriptionSelection}
                getFbToken={getFbToken}
                thumbnails={thumbnails}
                setStateInGrandparent={this.setStateInParent}
                needToRelaunchAd={needToRelaunchAd}
                idsOfCollectionAdsToConvert={
                  this.props.idsOfCollectionAdsToConvert
                }
                alterIdsOfCollectionAdsToConvert={
                  this.props.alterIdsOfCollectionAdsToConvert
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {processing ? (
          <div style={{ textAlign: 'center' }}>
            <span>
              {' '}
              <Loader inline className="active" /> Launching Ad...{' '}
            </span>
          </div>
        ) : null}
        <div>
          <Divider hidden />
          <Button attached="top" onClick={this.toggleDebugLog}>
            {debugLogOpen ? 'Close' : 'Open'} Debug Log{' '}
          </Button>
          <Segment basic style={{ marginTop: 0, padding: 0 }}>
            {debugLogOpen ? (
              <TextArea
                style={{
                  borderColor: '#e0e1e2',
                  borderTop: 'none'
                }}
                placeholder="Debug Log"
                disabled
                rows="18"
                value={
                  debugLogContent && debugLogContent.trim() !== ''
                    ? debugLogContent
                    : log
                }
              />
            ) : null}
          </Segment>
        </div>
      </div>
    );
  }
}

export default AdLibraryLaunch;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunch.js